import v from "voca";
// Add spaces between a pascal cased constant
// e.g) CreditNote -> Credit Note
export const formatSpacedString = (value: string) => {
  return v.words(value).join(" ");
};

// Add spaces between a pascal cased constant, leave only first word uppercase
// e.g) ReadyForAcceptance -> Ready for acceptance
export const formatSpacedStringSentenceCase = (value: string) => {
  const lowercased = v.words(value).join(" ").toLowerCase();
  return lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
};
